var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F2F1FF",
    fillRule: "nonzero",
    cx: 36,
    cy: 36,
    r: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.083 24.617v22.17c0 2.512 2.06 4.55 4.606 4.55h26.09c2.546 0 4.607-2.038 4.607-4.55V30.162c0-2.512-2.06-4.547-4.606-4.547H36.74a4.62 4.62 0 0 1-3.325-1.406l-2.654-2.736a4.632 4.632 0 0 0-3.328-1.406H22.69c-2.546 0-4.606 2.037-4.606 4.55z",
    fill: "#B2AAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.805 44.878h11.149",
    stroke: "#5340FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolder);
export default __webpack_public_path__ + "static/media/ic_folder.7366051602ca84a8c6cba74a1e50e005.svg";
export { ForwardRef as ReactComponent };